export const convertFileSizePreview = (fileSize) => {
  const units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  let l = 0, n = parseInt(fileSize, 10) || 0;
  while (n >= 1024 && ++l) {
    n = n / 1024;
  }
  return (n.toFixed(n < 10 && l > 0 ? 1 : 0) + ' ' + units[l]);
}

let counterForRandomInt = 1;
let prevRandom = 1;
export function getRandomInt(max) {
  let time = new Date().getTime();
  let randomValue = (time / counterForRandomInt) / (prevRandom + 1) % max;
  counterForRandomInt = counterForRandomInt + 1;
  prevRandom = randomValue;
  return parseInt(randomValue) + 1;
}